import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SalesDashboard from './SalesDashboard';
import FinanceDashboard from './FinanceDashboard';
import AdminDashboard from './AdminDashboard';
import DefaultDashboard from './Dashboard';
import TeacherHome from '../Teacher/TeacherHome';
import DashboardWithNews from '../../components/News/DashboardWithNews';

/**
 * One Dashboard per role. Teaching roles use Teaching home content here (not a second page).
 */
const DashboardRouter = () => {
  const { user, isAdmin, isTeacher, isTeachingLead, isSales, isFinanceOrAdmin, isParentFeedbackAgent, isBatchOps } =
    useAuth();

  if (!user) {
    return <DefaultDashboard />;
  }

  if (isParentFeedbackAgent()) {
    return <Navigate to="/students" replace />;
  }

  let main = <DefaultDashboard />;
  let wrapNews = true;
  if (isAdmin()) {
    main = <AdminDashboard />;
  } else if (isSales()) {
    main = <SalesDashboard />;
  } else if (isTeachingLead() || isTeacher() || isBatchOps()) {
    main = <TeacherHome />;
    wrapNews = false;
  } else if (isFinanceOrAdmin()) {
    main = <FinanceDashboard />;
  }

  if (!wrapNews) return main;
  return <DashboardWithNews>{main}</DashboardWithNews>;
};

export default DashboardRouter;
